import React from 'react';

const CustomDropdownToggle = React.forwardRef(({ onClick, children }, ref) => (
    <button
        type="button"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        className={"custom-bootstrap-toggle"}
    >
        {children}
    </button>
));

export default CustomDropdownToggle;